import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { OnDestroy, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LogoutService } from 'src/app/core';
import { EventTypeCount, HistoryEventType } from 'src/app/core/models/customer-details';
import { HttpService } from 'src/app/core/services/http-service';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogBoxComponent } from '../components/dialog-box/dialog-box.component';


@Injectable({
  providedIn: 'root'
})
export class DashboardService implements OnDestroy {

  public pageName: string;
  public startDateval;
  public endDateval;
  public vinNumber: string;
  public vehRegNumber: string;
  public unauthorizedLogoutMsg: any;
  // public isFilterNotEnabled = false;
  public coordinates = {
    lat: '',
    lng: ''
  };
  private emerContacts: Array<any>;
  private otherVehDetails: Array<any>;
  private secContDetails: Array<any>;
  checkCount = false;

  private dashbaordSource: Subject<any> = new Subject<any>();
  dashbaordSourceObservable = this.dashbaordSource.asObservable();
  public primaryMobileNo: any;
  public phone: any;
  public dashboardEvent(data: any) {
    this.dashbaordSource.next(data);
  }

  public setEmerContacts(emCont) {
    this.emerContacts = emCont;
  }

  public getEmerContacts = function() {
    return this.emerContacts;
  };

  public setOtherVehDetails(otherVehDet) {
    this.otherVehDetails = otherVehDet;
  }

  public getOtherVehDetails = function() {
    return this.otherVehDetails;
  };

  public setSecContactDetails(secContactDet) {
    this.secContDetails = secContactDet;
  }

  public getSecContactDetails = function() {
    return this.secContDetails;
  };

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    public router: Router,
    private logoutService: LogoutService,
    private ngBModalService: NgbModal
  ) {

  }

  fetchHistoryData(fdata): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getHistoryData;
    return this.httpService.postWithRefershToken(url, fdata).pipe(map((data: any) => {
      return data;
    }), catchError(this.errorMgmt));
  }

  fetchSecuirtyData(data): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getHistoryData;
    return this.httpService.postWithRefershToken(url, data).pipe(map((returnData: any) => {
      return returnData;
    }), catchError(this.errorMgmt));
  }

  fetchDashBoardCountData(): Observable<any> {
    const url = environment.apiUrl + environment.supportPortal.getLiveCount;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        refreshToken: localStorage.getItem('refreshToken'),
        deliteId: localStorage.getItem('userId')
      })
    };
    return this.http.get(url, httpOptions).pipe(map((data: any) => {
      return data;
    }), catchError(this.errorMgmt));
  }

  callCustomerCTI(requestData): Observable<any> {
    const url = environment.apiUrl + environment.cti.manualDialing;
    return this.httpService.postWithRefershToken(url, requestData).pipe(map((data: any) => {
      return data;
    }), catchError(this.errorMgmt));
  }

  backToLogin() {
    this.logoutService.logoutSvc().subscribe();
    localStorage.removeItem('userId');
    localStorage.removeItem('loggedInUserData');
    localStorage.removeItem('refreshToken');
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  openModal(heading, id, content) {
    const modalConfig = {
      heading,
      popupId: id,
      popUpContent: content
    };
    const modalRef = this.ngBModalService.open(DialogBoxComponent, {
      centered: true,
      keyboard: false,
      backdrop: 'static'
    });
    modalRef.componentInstance.modalConfig = modalConfig;
  }

  // --Check for Empty Object ---------//
  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }
  // --Check for Empty Object ---------//

  errorMgmt(error: HttpErrorResponse) {
    let errorMessage;
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = error;
    }
    return throwError(errorMessage);
  }

  ngOnDestroy() {
    this.dashbaordSource.next(undefined);
    this.dashbaordSource.complete();
  }
}
